/* eslint-disable max-len */
import React from 'react';

const Filters: React.FC<object> = () => {

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_8784_235488)">
                <path
                    d="M1.46841 0.666016H14.5317C15.3795 0.666016 15.8427 1.65487 15.2999 2.3062L10.2318 8.38788C10.082 8.5676 10 8.79413 10 9.02807V14.1308C10 14.9295 9.10989 15.4059 8.44533 14.9629L6.89063 13.9264C6.33424 13.5555 6.00003 12.931 6.00003 12.2623V9.02807C6.00003 8.79413 5.91802 8.5676 5.76825 8.38788L0.700187 2.3062C0.157413 1.65487 0.620571 0.666016 1.46841 0.666016Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_8784_235488">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Filters;